import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import Baseline from '@mui/material/CssBaseline';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Helmet } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { BrandLabel } from './constants';
import { ConfigContext } from 'context/config';
import Main from './Main';
import useIntercom from './hooks/useIntercom';
import { AlertProvider } from 'context/alert';
import AlertComponent from './components/AlertComponent';
import makeTheme from './theme';
import './styles/app.scss';

const UniversalApp = ({ config }) => {
  const darkMode = useSelector((s) => s.user.darkMode);
  const loggedIn = useSelector((s) => s.user.isLoggedIn);
  const stripePromise = useMemo(
    () => loadStripe(config.REACT_APP_STRIPE_PUB_KEY),
    [],
  );

  useIntercom();

  const brand = config.BRAND;
  const theme = useMemo(() => {
    return makeTheme(brand, loggedIn ? (darkMode ? 'dark' : 'light') : 'light');
  }, [brand, darkMode, loggedIn]);

  const brandLabel = BrandLabel[brand];

  return (
    <ConfigContext.Provider value={config}>
      <Elements stripe={stripePromise}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <MuiThemeProvider theme={theme}>
            <AlertProvider component={AlertComponent}>
              <Baseline />
              <Helmet title={brandLabel} titleTemplate={`%s | ${brandLabel}`} />
              <Main config={config} />
            </AlertProvider>
          </MuiThemeProvider>
        </LocalizationProvider>
      </Elements>
    </ConfigContext.Provider>
  );
};

export default UniversalApp;
